export const GET_UPGRADE = 'GET_UPGRADE';
export const LOGGED_IN = 'LOGGED_IN';
export const SET_BREADCRUMB_PATH = 'SET_BREADCRUMB_PATH';
export const SET_VISIBLE_COLUMN_COUNT = 'SET_VISIBLE_COLUMN_COUNT';
export const SET_UTILITY_COLUMN_COUNT = 'SET_UTILITY_COLUMN_COUNT';
export const SET_CSRF_TOKEN = 'SET_CSRF_TOKEN';